import * as Models from "../.";

export interface ICommercialSolarCustomerCaptureEnrollment {
  customer: Models.Customer.Customer.ICustomer;
  billingAddress: Models.Customer.Address.Address;
  serviceAddress: Models.Customer.Address.Address;
  rate: number;
  escalator: number;
  termLength: number;
  profitCenter: Models.PaymentCapture.ProfitCenter.ProfitCenter;
}

export class CommercialSolarCustomerCaptureEnrollment
  implements ICommercialSolarCustomerCaptureEnrollment {
  customer: Models.Customer.Customer.ICustomer;
  billingAddress: Models.Customer.Address.Address;
  serviceAddress: Models.Customer.Address.Address;
  rate: number;
  escalator: number;
  termLength: number;
  profitCenter: Models.PaymentCapture.ProfitCenter.ProfitCenter;
}

export class AutoGenerateGenNumberButton {
  text = "Yes";
  enabled = true;
}
